import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../../types/content';
import { ProductImage } from './ProductImage';
import { formatPriceRange } from '../../utils/price';
type ProductCardProps = {
  product: Product;
};
export function ProductCard({
  product
}: ProductCardProps) {
  const price = formatPriceRange(product);
  const cta = product.inHouse ? 'Read more' : product.soldOut ? 'Sold out' : product.options ? 'Select options' : 'Add to cart';
  return <Link to={`/product/${product.slug}`} className="group flex h-full flex-col" data-id="element-206" data-mp="1t302bz56yxd7">
      <div className="relative aspect-square overflow-hidden bg-ink-surface" data-id="element-207" data-mp="272izxy0dmqb9">
        <ProductImage product={product} className="transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-208" data-mp="270eydmpya3e5" />
        {product.soldOut && <span className="absolute left-3 top-3 bg-white px-2 py-1 font-slab text-[10px] font-bold uppercase tracking-[0.2em] text-ink" data-id="element-209" data-mp="cnotk9y1n9rz">Sold</span>}
      </div>
      <p className="mt-4 text-xs uppercase tracking-[0.15em] text-ink-faint" data-id="element-210" data-mp="3gs07p6rqyrg4">{product.categories.join(', ')}</p>
      <h3 className="mt-1 font-slab text-base font-bold uppercase leading-snug tracking-[0.1em]" data-id="element-211" data-mp="3lqtj8tnh48dn">{product.name}</h3>
      {price && <p className="mt-2 font-slab tracking-wider text-ink-muted" data-id="element-212" data-mp="3qp4th5hokkwe">{price}</p>}
      <span className="mt-auto pt-4 font-slab text-xs font-bold uppercase tracking-[0.2em] underline-offset-8 group-hover:underline" data-id="element-213" data-mp="3vheh2evbp8vi">{cta}</span>
    </Link>;
}